import actionTypes from './actionTypes'

const flipgridActions = {

	initializeSuccess(data) {
		return {
			type: actionTypes.FLIPGRID_CREATION_TOOL_INITIALIZE_SUCCESS,
			data,
		}
	},
	initializeError(error) {
		return {
			type: actionTypes.FLIPGRID_CREATION_TOOL_INITIALIZE_ERROR,
			error,
		}
	},
	updateInput(value, role) {
		return {
			type: actionTypes.FLIPGRID_CREATION_TOOL_UPDATE_INPUT,
			value,
			role,
		}
	},
	saveCreation() {
		return {
			type: actionTypes.FLIPGRID_CREATION_TOOL_SAVE,
		}
	},
	saveCreationSuccess() {
		return {
			type: actionTypes.FLIPGRID_CREATION_TOOL_SAVE_SUCCESS,
		}
	},
	saveCreationError(message) {
		return {
			type: actionTypes.FLIPGRID_CREATION_TOOL_SAVE_ERROR,
			message,
		}
	},
	cancelCreation() {
		return {
			type: actionTypes.FLIPGRID_CREATION_TOOL_CANCEL,
		}
	},
	selectFlipgridHelp() {
		return {
			type: actionTypes.FLIPGRID_HELP_SELECTED,
		}
	},

}

export default flipgridActions
